import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetAllParticipantsQueryResponse, GetAllParticipantsQueryParams, GetAllParticipants400, GetAllParticipants401, GetAllParticipants403, GetAllParticipants422, GetAllParticipants429, GetAllParticipants500 } from "../types/GetAllParticipants";

export const getAllParticipantsQueryKey = (params: GetAllParticipantsQueryParams) =>     [{url:`/api/purchase-tenders/v1/show_all_participants`},...(params ? [params] : [])] as const;
      export function getAllParticipantsQueryOptions <TData = GetAllParticipantsQueryResponse, TError = GetAllParticipants400 | GetAllParticipants401 | GetAllParticipants403 | GetAllParticipants422 | GetAllParticipants429 | GetAllParticipants500>(params: GetAllParticipantsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getAllParticipantsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/show_all_participants`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/show_all_participants
 */

export function useGetAllParticipants <TData = GetAllParticipantsQueryResponse, TError = GetAllParticipants400 | GetAllParticipants401 | GetAllParticipants403 | GetAllParticipants422 | GetAllParticipants429 | GetAllParticipants500>(params: GetAllParticipantsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAllParticipantsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getAllParticipantsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
